import { Box } from '@bridebook/ui';
import ContentAccordion, {
  IProps as IContentAccordionProps,
} from '@bridebook/web/app-shared/components/content-accordion/content-accordion';
import componentStyles from './supplier-accordion.style';

interface IProps extends Omit<IContentAccordionProps, 'toggleContentAccordion'> {
  icon?: JSX.Element;
  toggleSupplierAccordion: (name: string) => void;
  horizontalMargins?: boolean;
}

export type IAccordionProps = {
  accordions: IProps['accordions'];
  toggleSupplierAccordion: IContentAccordionProps['toggleContentAccordion'];
};

const SupplierAccordion = ({ toggleSupplierAccordion, ...props }: IProps) => {
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      <ContentAccordion {...props} toggleContentAccordion={toggleSupplierAccordion} />
    </Box>
  );
};

export default SupplierAccordion;
